import { CheckoutStripeInput } from "@/offering/template_offering_checkout_stripe_base";
import { FormikErrors, FormikTouched } from "formik";
import { useCallback, useRef } from "react";

export function useFadeInErrors(
  errors: FormikErrors<CheckoutStripeInput>,
  touched: FormikTouched<CheckoutStripeInput>
) {
  const errorsRef = useRef<Map<string, HTMLElement>>(new Map());

  const fadeInErrors = useCallback(() => {
    const keyFrames: Keyframe[] = [{ opacity: 0 }, { opacity: 1 }];

    const options: KeyframeAnimationOptions = {
      duration: 1000,
      iterations: 1,
      easing: "ease-in",
    };

    errorsRef.current.forEach((e) => e.animate(keyFrames, options));
  }, [errorsRef]);

  const handleErrorTextRef = (
    ref: HTMLElement | null,
    errorId: keyof CheckoutStripeInput
  ) => {
    if (ref && touched[errorId] && errors[errorId]) {
      errorsRef.current.set(errorId, ref);
    } else {
      errorsRef.current.delete(errorId);
    }
  };

  const handleInputBorderRef = (
    ref: HTMLElement | null,
    errorId: keyof CheckoutStripeInput
  ) => {
    if (ref && touched[errorId] && errors[errorId]) {
      errorsRef.current.set(`${errorId}-border`, ref);
    } else {
      errorsRef.current.delete(`${errorId}-border`);
    }
  };

  return { handleErrorTextRef, handleInputBorderRef, fadeInErrors };
}
